<template>
  <v-row align="center" justify="center" no-gutters style="height: 100%">
    <v-card class="item" elevation="24">
      <v-card-title class="ma-2 justify-center text-h3 font-weight-bold">
        {{ siteName }}
      </v-card-title>
      <v-card-text class="py-2 pa-sm-4">
        <v-text-field
          label="請輸入認證碼"
          prepend-icon="mdi-lock"
          :type="showCode ? 'text' : 'password'"
          :append-icon="showCode ? 'mdi-eye' : 'mdi-eye-off'"
          v-model="code"
          @click:append="showCode = !showCode"
          @keyup.enter="login"
          autofocus
          inputmode="numeric"
        />
        <div class="text-center text-body-2 font-weight-bold red--text">
          提示: 認證碼為長輩身分證號後4碼+生日後4碼 <br />
          Ex:A123456789、33年1月1日，驗證碼:67890101
        </div>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-btn color="primary" @click="login" block class="font-weight-bold"> 登入 </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { bus } from '@/bus.js'
export default {
  inject: ['siteName'],
  data() {
    return {
      id: null,
      code: '',
      showCode: false,
    }
  },
  methods: {
    async login() {
      const payload = qs.stringify({ code: this.code })
      try {
        const res = await axios.post('/api/attendance/login', payload, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        if (res.data.status === 'success') {
          this.id = res.data.data.case_num
          this.elder_name = res.data.data.name
          localStorage.setItem('id', this.id)
          localStorage.setItem('elder_name', this.elder_name)
          localStorage.setItem('isUserLogin', true)
          bus.$emit('user-logged-in', this.elder_name)
          this.$router.replace({ path: `/contactbook/home` })
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
<style scoped>
.item {
  align-content: center;
  height: 50vh;
  margin: 16px;
  padding: 32px;
}
</style>
